export default {"src":"/polygon/_next/static/media/fund_7.65dcfc90.svg","height":80,"width":231};